var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"section",staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('h1',{staticClass:"title"},[_vm._v("Diese Funktion ist bald verfügbar.")]),_c('div',{staticClass:"figure"},[_c('img',{attrs:{"src":"/assets/women_grass_tree.png"}})])])])
}]

export { render, staticRenderFns }